import { RootState } from '../reducers'

export const actualiteSelector = (state: RootState, id: number) => state.actualites[id]

export const newsSelector = (state: RootState) => (state.news ? state.news.paging.content : [])

export const lastPageSelector = (state: RootState) => (state.news.paging ? state.news.paging.last : null)

export const newsPagingSelector = (state: RootState) => state.news.paging
